import {
	apiService,
	getController,
	type HpRequestPostPut,
} from '@/services/service'

const url = 'assfinet/damage_report'

export const assfinetDamageReportService = {
	...getController(url), //TODO:: Type missing
	createContractDamageReport: (
		contractId: number,
		reportId: number,
		data: HpRequestPostPut<any>
	) =>
		apiService.post({
			url: `assfinet/contracts/${contractId}/damage_report/${reportId}`,
			...data,
		}),
}

export default assfinetDamageReportService
